import { getSubPlaylistUrl } from './PlaylistUtils';

const MASTER_V4_SPEAKER_PLAYLIST_FILE_NAME_REGEX = /#EXT-X-SESSION-DATA:DATA-ID="vbrick.speaker",VALUE="(.+\.m3u8.*)"/;

export class MasterPlaylistParserHelperV4 {
	public static getSpeakerPlaylistUrl(masterPlaylistUrl: string, masterPlaylistString: string, queryParms?: {[key: string]: any}): string {
		const [, speakerPlaylistFilename] = masterPlaylistString.match(MASTER_V4_SPEAKER_PLAYLIST_FILE_NAME_REGEX);

		return getSubPlaylistUrl(masterPlaylistUrl, appendQueryParams(speakerPlaylistFilename, queryParms));
	}
}

function appendQueryParams(speakerPlaylistFilename: string, queryParms: {[key: string]: any}): string {
	if (!queryParms) {
		return speakerPlaylistFilename;
	}

	const [fileName, queryStr] = speakerPlaylistFilename.split('?');
	const queryParamsStr = Object.entries(queryParms)
		.reduce((output, [key, value]) => {
			if (output.length) {
				output += '&';
			}

			output += `${key}=${value}`;

			return output;
		}, '');

	return `${fileName}?${queryStr ? queryStr + '&' : ''}${queryParamsStr}`;
}
